import React from "react";
import axios from "axios";
import { Row, Container, Col, Form, Button, Pagination } from "react-bootstrap";
import { t } from "../../localization/localization";
import CustomPagination from "../../components/pagination";

export default class ScimagoWorldwide extends React.Component {
  state = {
    institutions: [],
    searchText: "",
    currentPage: 1,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    axios
      .get(`${window._env_.BASE_URL}/gcris-api/report/scimagoAll`)
      .then((res) => {
        this.setState({
          institutions: res.data.map((e) => ({
            id: e.id,
            text: e.institution,
            checked: false,
          })),
        });
      });
  };

  changeChecked = (id) => {
    const insIndex = this.state.institutions.findIndex((ins) => ins.id === id);
    let newArray = [...this.state.institutions];
    newArray[insIndex] = {
      ...newArray[insIndex],
      checked: !newArray[insIndex].checked,
    };
    this.setState({
      institutions: newArray,
    });
  };

  handleSearchChange = (value) => {
    this.setState({ searchText: value.toLowerCase() });
    this.setState({ currentPage: 1 });
  };

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";
    const itemsPerPage = 50;
    const idpsQueryParam = this.state.institutions
      .filter((ins) => ins.checked)
      .map((ins) => "idps[]=" + ins.id)
      .join("&");

    const filteredInstitutions = this.state.institutions.filter((ins) =>
      ins.text.toLowerCase().startsWith(this.state.searchText)
    );

    const totalPages = Math.ceil(filteredInstitutions.length / itemsPerPage);

    const indexOfLastItem = this.state.currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const handlePageChange = (page) => {
      this.setState({
        currentPage: page,
      });
    };

    const paginatedInstitutions = filteredInstitutions.slice(
      indexOfFirstItem,
      indexOfLastItem
    );

    return (
      <Container>
        <Row className="mb-2">
          <Col xs="12">
            <h4 style={{ color: "#001F54" }}>
              {t(locale, "/reports/scimagoWorldwide/title")}
            </h4>
            <Form.Control
              size="sm"
              type="text"
              className="mb-2"
              placeholder={t(locale, "/reports/scimagoWorldwide/search")}
              onChange={(e) => this.handleSearchChange(e.target.value)}
              value={this.state.searchText}
            />
            <Form style={{ height: 300, overflowY: "scroll" }}>
              {paginatedInstitutions.map((ins) => {
                return (
                  <Form.Check
                    key={ins.id}
                    type="checkbox"
                    id={ins.id}
                    label={ins.text}
                    onChange={() => this.changeChecked(ins.id)}
                    checked={ins.checked}
                  />
                );
              })}
            </Form>
          </Col>
        </Row>
        <Row>
          <Col>
            <CustomPagination
              currentPage={this.state.currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              disabled={idpsQueryParam === ""}
              href={"https://www.scimagoir.com/compare.php?" + idpsQueryParam}
              style={{ marginTop: 16 }}
              target="_blank"
            >
              {t(locale, "/reports/scimagoWorldwide/compare")}
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}
